import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Title from 'Components/Title'
import Upload from 'Components/Upload'
import React from 'react'


export default React.memo(props => <Title inline={props.inline} title={props.title}>
        <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'} alignItems={'center'}>
          <Grid item xs style={{margin: 0, padding: 0}}>
            <Input style={props.style}
              onChange={props.onChangeSaisieLibreBool}
              name={'text'}
              disabled={props.disabled || false}
              value={props.data !== undefined && props.data.text !== undefined ? props.data.text : ""}
            />
          </Grid>
          {props.client_id && <Grid item style={{margin: 0, padding: 0}}>
            <Upload disabled={props.disabled || false} media_id={props.data && props.data.valeur_entier} link={props.data && props.data.media_lien} client_id={props.client_id} onChange={(r) => props.onChangeSaisieLibreUpload(r.id, r.lien)}/>
          </Grid> }
        </Grid>
      </Title>)



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/SaisieLibreDocument.js